import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import RmMaterials from '../../components/Cards/RmMaterials';
import RmCompetences from '../../components/Cards/Rm/Competences';
import RmJobs from '../../components/Cards/Rm/Jobs';
import RmLanguages from '../../components/Cards/Rm/Languages';
import RmQualifications from '../../components/Cards/Rm/Qualifications';
import ButtonCircle from '../../components/Common/ButtonCircle';
import {RadarChart} from '../../components/CommonComponents';
import {RmInfo} from '../../components/CompanyComponents';
import {openDialog} from '../../slices/dialog';
import {selectUser} from '../../slices/profile';
import {selectSelectedRm} from '../../slices/selected';
import EditIcon from "@material-ui/icons/Edit";
import {CompanyRmTutorial} from '../../components/Dialog/Company/RmTutorial';
import {Cookies} from "react-cookie-consent";
import {ROUTES} from '../../db/models/const';
import {getRmContentsListener} from '../../api/content';

export const CompanyRm = () => {
    const dispatch = useDispatch();
    const rm = useSelector(selectSelectedRm);
    const user = useSelector(selectUser);
    const logoUrl = user?.logoUrl || "";
    const history = useHistory();
    const [video, setVideo] = useState();

    const onSoftSkillsEdit = () => {
        history.push(ROUTES.COMPANY_RM_EDIT_SOFT);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        const tutorialDone = Cookies.get("rmTutorialDone");
        if (!tutorialDone)
            dispatch(openDialog({
                Content: CompanyRmTutorial,
                props: {},
                closable: false,
                narrow: true
            }));
    }, [])

    useEffect(() => {
        if (!rm) return;

        const unsub = getRmContentsListener(rm.id, snapshot => {
            const contents = [];
            snapshot.docs.forEach(doc => {
                if (doc.exists) contents.push(doc.data());
            });
            setVideo(contents?.[0]);
        });

        return unsub;
    }, [rm])

    return (
        <div className="companyRm">
            <div className="companyRm__rmInfo card">
                <RmInfo rm={rm} logoUrl={logoUrl} video={video}/>
            </div>
            <div className="companyRm__radar card" style={{alignItems: 'center'}}>
                <RadarChart softSkills={rm?.softSkills} onClick={() => {
                }}/>
                <div className="floatTopActions">
                    <ButtonCircle onClick={() => onSoftSkillsEdit()}><EditIcon/></ButtonCircle>
                </div>
            </div>
            <RmQualifications qualifications={Object.values(rm?.bg?.qualifications || {})}/>
            <RmJobs jobs={Object.values(rm?.bg?.jobs || {})}/>
            <RmCompetences competences={Object.values(rm?.bg?.competences || {})}/>
            <RmLanguages languages={Object.values(rm?.bg?.languages || {})}/>
            <RmMaterials materials={Object.values(rm?.bg?.materials || {})}/>
        </div>
    )
}